import { useCallback, useMemo } from 'react';
import { Anything } from 'src/types';

import { Container, SuperQuicks, Quicks, IconButton } from './styles';
import { TypeIcon } from 'src/Components/Icons';

import { SUPPORTED_ANYTHING_TYPES } from 'src/constants/app';
export const NEW_CUSTOM_TYPE = Symbol('NEW_CUSTOM_TYPE');

type SupportedTypesProps = {
  onChange: (type: Anything['type'] | typeof NEW_CUSTOM_TYPE) => void;
  exclude?: string[];
};

export const SupportedTypes = ({
  onChange,
  exclude = [],
}: SupportedTypesProps) => {
  const handleBtnClick = useCallback(
    (el) => {
      const type = el.target.value;
      onChange(type);
    },
    [onChange]
  );

  const types = useMemo(() => {
    return SUPPORTED_ANYTHING_TYPES.filter((type) => !exclude.includes(type));
  }, [exclude]);

  return (
    <Container>
      <SuperQuicks>
        <IconButton
          $color="danger"
          title="POSITION"
          value="POSITION"
          onClick={handleBtnClick}
        >
          <TypeIcon type="POSITION" />
        </IconButton>
        <IconButton
          $color="primary"
          title="DATE"
          value="DATE"
          onClick={handleBtnClick}
        >
          <TypeIcon type="DATE" />
        </IconButton>
        <IconButton
          $color="danger"
          title="DATETIME"
          value="DATETIME"
          onClick={handleBtnClick}
        >
          <TypeIcon type="DATETIME" />
        </IconButton>
      </SuperQuicks>

      <Quicks>
        {types.map((type) => {
          return (
            <IconButton
              key={type}
              title={type}
              value={type}
              onClick={handleBtnClick}
            >
              <TypeIcon type={type} />
            </IconButton>
          );
        })}
        <IconButton
          title="Add a new custom type"
          outline
          onClick={() => onChange(NEW_CUSTOM_TYPE)}
          style={{ borderColor: '#AAA', marginLeft: '1em' }}
        >
          <TypeIcon type={NEW_CUSTOM_TYPE} />
        </IconButton>
      </Quicks>
    </Container>
  );
};
